import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import { cn } from '../../../utils/cn';

const TutorialCard = ({ tutorial }) => {
  const getDifficultyColor = (difficulty) => {
    switch (difficulty) {
      case 'beginner':
        return 'text-success bg-success/10';
      case 'intermediate':
        return 'text-warning bg-warning/10';
      case 'advanced':
        return 'text-error bg-error/10';
      default:
        return 'text-muted-foreground bg-muted';
    }
  };

  const getTypeIcon = (type) => {
    switch (type) {
      case 'video':
        return 'Video';
      case 'document':
        return 'FileText';
      default:
        return 'BookOpen';
    }
  };

  return (
    <div className="bg-card border border-border rounded-lg overflow-hidden transition-smooth hover:shadow-lg hover:-translate-y-1">
      {/* Thumbnail */}
      <div className="relative h-48 bg-muted overflow-hidden">
        <img
          src={tutorial?.thumbnail}
          alt={tutorial?.alt}
          className="w-full h-full object-cover"
        />
        {tutorial?.completed && (
          <div className="absolute top-3 right-3 bg-success text-success-foreground px-3 py-1 rounded-full flex items-center gap-1.5 text-xs font-semibold">
            <Icon name="CheckCircle" size={14} color="currentColor" />
            Completed
          </div>
        )}
        <div className="absolute bottom-3 left-3 bg-background/90 backdrop-blur-sm px-3 py-1 rounded-full flex items-center gap-1.5 text-xs font-semibold">
          <Icon name={getTypeIcon(tutorial?.type)} size={14} color="var(--color-primary)" />
          {tutorial?.type === 'video' ? 'Video Tutorial' : 'Document'}
        </div>
      </div>

      {/* Content */}
      <div className="p-5">
        <div className="flex items-start justify-between mb-3">
          <h3 className="text-lg font-heading font-semibold text-foreground leading-tight flex-1">
            {tutorial?.title}
          </h3>
        </div>

        <p className="text-sm text-muted-foreground mb-4 line-clamp-2">
          {tutorial?.description}
        </p>

        {/* Metadata */}
        <div className="flex items-center gap-3 mb-4 text-xs text-muted-foreground">
          <div className="flex items-center gap-1">
            <Icon name="Clock" size={14} color="currentColor" />
            <span>{tutorial?.duration}</span>
          </div>
          <div className={cn(
            'px-2 py-1 rounded-full font-semibold capitalize',
            getDifficultyColor(tutorial?.difficulty)
          )}>
            {tutorial?.difficulty}
          </div>
        </div>

        {/* Action Button */}
        <Button
          fullWidth
          variant={tutorial?.completed ? 'outline' : 'default'}
          iconName={tutorial?.completed ? 'RotateCcw' : 'Play'}
        >
          {tutorial?.completed ? 'Review Tutorial' : 'Start Tutorial'}
        </Button>
      </div>
    </div>
  );
};

export default TutorialCard;